const Bnb = () => (
    <svg
        width='29'
        height='29'
        viewBox='0 0 29 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M28.5627 18.0077C26.626 25.7756 18.7585 30.503 10.9897 28.5659C3.22416 26.6292 -1.50324 18.7613 0.434298 10.9939C2.37003 3.22513 10.2376 -1.50273 18.004 0.433906C25.7723 2.37054 30.4993 10.2394 28.5627 18.0077Z'
            fill='#F3BA2F'
        />
        <path
            d='M16.5165 20.6963V22.9541L14.5513 24.1096L12.6448 22.9541V20.6963L14.5513 21.8518L16.5165 20.6963ZM6 12.8951L7.9065 14.0515V17.9223L11.2005 19.8875V22.1406L6 19.0778V12.8951ZM23.1035 12.8951V19.0778L17.8453 22.1406V19.8875L21.1383 17.9223V14.0515L23.1035 12.8951ZM17.8453 9.83318L19.8095 10.9886V13.2427L16.5165 15.207V19.1337L14.6091 20.2891L12.7026 19.1337V15.207L9.29398 13.2427V10.9886L11.2583 9.83318L14.5513 11.7975L17.8453 9.83318ZM9.29398 14.8603L11.2005 16.0158V18.2689L9.29398 17.1135V14.8603ZM19.8095 14.8603V17.1135L17.903 18.2689V16.0158L19.8095 14.8603ZM7.9065 7.87171L9.8745 9.02437L7.9093 10.1798V12.433L6.0028 11.2775V9.02437L7.9065 7.87171ZM21.1961 7.87171L23.1613 9.02716V11.2803L21.1961 12.4358V10.1798L19.2859 9.02437L21.1961 7.87171ZM14.5513 7.87171L16.5165 9.02716L14.5513 10.1826L12.6448 9.02716L14.5513 7.87171ZM14.5513 4L19.8095 7.06289L17.903 8.21834L14.6091 6.25314L11.2545 8.21834L9.34802 7.06289L14.5513 4Z'
            fill='white'
        />
    </svg>
);

export default Bnb;
